/* ============================================================
   rewards-panel.js  —  assets/
   ============================================================ */

(function () {
  'use strict';

  const panel = document.getElementById('rewards-panel');
  if (!panel) return;

  const customerId = panel.dataset.customerId;
  let   cartTotal  = parseInt(panel.dataset.cartTotal, 10) || 0; // mutable — updates on cart change
  const PROXY      = '/apps/rewards';
  const LS_KEY     = `rp_applied_${customerId}`;

  /* ── Elements ── */
  const elBalance    = document.getElementById('rp-balance');
  const elBalance2   = document.getElementById('rp-balance-2');
  const elBalanceRs  = document.getElementById('rp-balance-rs');
  const elToggle     = document.getElementById('rp-toggle');
  const elToggleLoad = document.getElementById('rp-toggle-loading');
  const elHistList   = document.getElementById('rp-history-list');
  const elEarnNote   = document.getElementById('rp-earn-note');
  const elEarnTxt    = document.getElementById('rp-earn-txt');
  const elApplied    = document.getElementById('rp-applied');
  const elAppliedTxt = document.getElementById('rp-applied-txt');
  const elConflict   = document.getElementById('rp-conflict-notice');
  const elConflictTxt= document.getElementById('rp-conflict-txt');
  const elRemoveApp  = document.getElementById('rp-remove-applied');

  /* ── State — defined before any functions that use it ── */
  let state = {
    balance:      0,
    history:      [],
    isFirstOrder: false,
    appliedCode:  null,
    appliedPts:   0,
    initialized:  false  // guard: don't run coupon check before init
  };

  /* ── localStorage ── */
  function saveApplied(code, pts) {
    try { localStorage.setItem(LS_KEY, JSON.stringify({ code, pts, ts: Date.now() })); } catch {}
  }
  function loadApplied() {
    try {
      const data = JSON.parse(localStorage.getItem(LS_KEY));
      if (!data) return null;
      if (Date.now() - data.ts > 2 * 60 * 60 * 1000) { localStorage.removeItem(LS_KEY); return null; }
      return data;
    } catch { return null; }
  }
  function clearApplied() { try { localStorage.removeItem(LS_KEY); } catch {} }

  /* ── Helpers ── */
  function calcMaxPts() {
    const fiftyPct = Math.floor(cartTotal / 200);
    return Math.min(state.balance, fiftyPct);
  }

  /* ── Discount field lock/unlock ──
     Prestige renders the discount input inside .cart-discount
     Selector: .cart-discount input[name="discount"], or input[type="text"] inside it
  ── */
  /* ── Discount field lock/unlock ──
     Prestige's cart-discount.liquid structure:
     .cart-discount > cart-discount-field > input:not([type=hidden])
                                          > button.cart-discount-field__apply-btn
  ── */
  /* ── Get discount field elements ──
     Tries multiple selectors to handle Prestige's cart-discount structure.
     Logs what it finds so we can debug if needed.
  ── */
  function getDiscountElements() {
    // Try all possible selectors for the visible input
    const input = (
      document.querySelector('.cart-discount-field input:not([type="hidden"])') ||
      document.querySelector('cart-discount-field input:not([type="hidden"])') ||
      document.querySelector('.cart-discount input[type="text"]') ||
      document.querySelector('.cart-discount input:not([type="hidden"])')
    );

    const button = (
      document.querySelector('.cart-discount-field__apply-btn') ||
      document.querySelector('.cart-discount button[type="button"]') ||
      document.querySelector('.cart-discount button')
    );

    const field = (
      document.querySelector('cart-discount-field') ||
      document.querySelector('.cart-discount-field')
    );

    const cartDiscount = document.querySelector('.cart-discount');

    console.log('[RewardsPanel] discountField found:', { input: !!input, button: !!button, field: !!field });
    return { input, button, field, cartDiscount };
  }

  function lockDiscountField() {
    document.body.classList.add('rp-points-active');
    const notice = document.getElementById('rp-points-lock-notice');
    if (notice) notice.style.display = 'flex';
  }

  function unlockDiscountField() {
    document.body.classList.remove('rp-points-active');
    const notice = document.getElementById('rp-points-lock-notice');
    if (notice) notice.style.display = 'none';
  }

  // showDiscountFieldWarning / hideDiscountFieldWarning replaced by
  // direct show/hide of #rp-points-lock-notice in liquid

  /* ── Coupon detection ── */
  function getActiveCouponCode() {
    const badge = document.querySelector('.discount-badge');
    if (!badge) return null;
    const text = badge.textContent.trim().split('(')[0].trim();
    return text || null;
  }

  function checkCouponConflict() {
    if (!state.initialized) return false; // skip before init completes

    const code = getActiveCouponCode();
    const isRwrd = code && code.startsWith('RWRD-');
    const hasExternalCoupon = code && !isRwrd;

    if (hasExternalCoupon) {
      if (elConflict) {
        elConflictTxt.textContent = `Coupon "${code}" is applied. Remove it to use points.`;
        elConflict.style.display  = 'flex';
      }
      if (!state.appliedCode) {
        elToggle.disabled      = true;
        elToggle.style.opacity = '0.4';
      }
      return true;
    } else {
      if (elConflict) elConflict.style.display = 'none';
      if (!state.appliedCode) {
        const maxPts           = calcMaxPts();
        elToggle.disabled      = maxPts <= 0;
        elToggle.style.opacity = '';
      }
      return false;
    }
  }

  /* ── Shake animation ── */
  function shakeToggle() {
    elToggle.classList.remove('rp-shake');
    void elToggle.offsetWidth;
    elToggle.classList.add('rp-shake');
    elToggle.addEventListener('animationend', () => {
      elToggle.classList.remove('rp-shake');
    }, { once: true });
  }

  /* ── Spinner ── */
  function showToggleSpinner() {
    if (elToggleLoad) elToggleLoad.style.display = 'flex';
    elToggle.disabled = true;
  }
  function hideToggleSpinner() {
    if (elToggleLoad) elToggleLoad.style.display = 'none';
  }

  /* ── UI states ── */
  function showFreshState() {
    const maxPts           = calcMaxPts();
    elToggle.setAttribute('aria-checked', 'false');
    elToggle.disabled      = maxPts <= 0;
    elToggle.style.opacity = '';
    elApplied.style.display = 'none';
    const form = panel.closest('form[action]');
    if (form) delete form.dataset.rwrdIntercepted;
    delete panel.dataset.pendingDiscount;
    unlockDiscountField(); // re-enable coupon input
  }

  function showAppliedState(code, pts) {
    elToggle.setAttribute('aria-checked', 'true');
    elToggle.disabled        = false;
    elToggle.style.opacity   = '';
    elApplied.style.display  = 'flex';
    elAppliedTxt.textContent = `${pts.toLocaleString('en-IN')} pts applied — ₹${pts.toLocaleString('en-IN')} off at checkout`;

    // Freeze usable display
    if (elBalance2)  elBalance2.textContent  = pts.toLocaleString('en-IN');
    if (elBalanceRs) elBalanceRs.textContent = pts.toLocaleString('en-IN');
    const capNotice = document.getElementById('rp-cap-notice');
    if (capNotice) capNotice.style.display = 'none';
    if (elConflict) elConflict.style.display = 'none';

    updateCartTotalDisplay(pts);
    lockDiscountField(); // disable coupon input while points are active
  }

  /* ── Render balance ── */
  function renderBalance() {
    const maxPts   = calcMaxPts();
    const fiftyPct = Math.floor(cartTotal / 200);
    const isCapped = state.balance > fiftyPct;

    elBalance.textContent = state.balance.toLocaleString('en-IN');
    const badge = elBalance.closest('.rewards-panel__balance-badge');
    if (badge) badge.style.display = state.balance > 0 ? '' : 'none';

    if (!state.appliedCode) {
      if (elBalance2)  elBalance2.textContent  = maxPts.toLocaleString('en-IN');
      if (elBalanceRs) elBalanceRs.textContent = maxPts.toLocaleString('en-IN');

      const capNotice = document.getElementById('rp-cap-notice');
      if (capNotice) {
        if (isCapped && state.balance > 0) {
          capNotice.textContent   = `Max ${fiftyPct.toLocaleString('en-IN')} pts usable (50% of cart value)`;
          capNotice.style.display = '';
        } else {
          capNotice.style.display = 'none';
        }
      }
    }
  }

  /* ── Earn note ── */
  function updateEarnNote(cartPaise, ptsUsed) {
    const payable = Math.max(0, (cartPaise || 0) - (ptsUsed || 0) * 100);
    let earn = state.isFirstOrder
      ? Math.floor(payable / 200)
      : Math.floor(payable / 10000);
    earn = isNaN(earn) || earn < 0 ? 0 : earn;
    elEarnTxt.textContent    = earn.toLocaleString('en-IN');
    elEarnNote.style.display = 'flex';
  }

  /* ── Cart total display ── */
  function updateCartTotalDisplay(ptsUsed) {
    const totalRow = document.querySelector('.cart-recap .h-stack.justify-start.gap-2');
    if (!totalRow) return;
    const amtSpan = totalRow.querySelectorAll('.text-lg')[1];
    if (!amtSpan) return;

    if (ptsUsed > 0) {
      const payable   = Math.max(0, cartTotal - ptsUsed * 100);
      const payableRs = (payable / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      amtSpan.textContent = 'Rs. ' + payableRs + ' INR';
      amtSpan.style.color = '#1a7a4a';
      amtSpan.title       = 'After ' + ptsUsed + ' pts discount';
    } else {
      const originalRs = (cartTotal / 100).toLocaleString('en-IN', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      amtSpan.textContent = 'Rs. ' + originalRs + ' INR';
      amtSpan.style.color = '';
      amtSpan.title       = '';
    }
  }

  /* ── History ── */
  function renderHistory() {
    if (!state.history.length) {
      elHistList.innerHTML = '<div class="rewards-panel__history-empty">No activity yet.</div>';
      return;
    }
    elHistList.innerHTML = state.history.slice(0, 10).map(h => {
      const isEarn = h.type === 'earn';
      const pts    = Math.abs(h.points);

      // Simple human-readable label
      let label;
      if (h.is_expiry)       label = 'Points expired';
      else if (h.is_welcome) label = 'Welcome bonus';
      else if (h.is_manual)  label = h.description;
      else if (isEarn)       label = `${pts.toLocaleString('en-IN')} pts earned on purchase`;
      else                   label = `${pts.toLocaleString('en-IN')} pts redeemed`;

      return `<div class="rewards-panel__history-item">
        <span class="rewards-panel__history-dot rewards-panel__history-dot--${isEarn ? 'earn' : 'use'}"></span>
        <span class="rewards-panel__history-desc">${esc(label)}</span>
        <span class="rewards-panel__history-pts rewards-panel__history-pts--${isEarn ? 'earn' : 'use'}">${isEarn ? '+' : '−'}${pts.toLocaleString('en-IN')}</span>
      </div>`;
    }).join('');
  }

  function esc(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Cart attribute sync ── */
  async function syncCartAttribute(code) {
    try {
      await fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ attributes: { rewards_discount_code: code } })
      });
    } catch {}
  }

  /* ── Refresh balance ── */
  async function refreshBalance() {
    try {
      const res  = await fetch(`${PROXY}/points?customer_id=${customerId}`);
      const data = await res.json();
      state.balance  = data.balance  || 0;
      state.history  = data.history  || [];
      renderBalance();
      renderHistory();
    } catch (e) {
      console.error('[RewardsPanel] refreshBalance:', e);
    }
  }

  /* ── Checkout intercept ── */
  function setupCheckoutIntercept(code) {
    panel.dataset.pendingDiscount = code;
    const form = panel.closest('form[action]');
    if (!form || form.dataset.rwrdIntercepted) return;
    form.dataset.rwrdIntercepted = 'true';
    form.addEventListener('submit', function (e) {
      const pendingCode = panel.dataset.pendingDiscount;
      if (!pendingCode) return;
      if (e.submitter && e.submitter.name === 'checkout') {
        e.preventDefault();
        window.location.href = `/checkout?discount=${encodeURIComponent(pendingCode)}`;
      }
    });
  }

  /* ── Remove applied ── */
  async function removeApplied() {
    showToggleSpinner();
    try {
      if (state.appliedCode) {
        await fetch(`${PROXY}/restore`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            customer_id:   customerId,
            points:        state.appliedPts,
            discount_code: state.appliedCode
          })
        });
      }
      await syncCartAttribute('');
    } catch (e) {
      console.error('[RewardsPanel] restore error:', e);
    }

    state.appliedCode = null;
    state.appliedPts  = 0;
    clearApplied();

    const form = panel.closest('form[action]');
    if (form) delete form.dataset.rwrdIntercepted;
    delete panel.dataset.pendingDiscount;

    await refreshBalance();
    showFreshState();
    updateEarnNote(cartTotal, 0);
    updateCartTotalDisplay(0);
    hideToggleSpinner();
    checkCouponConflict();
  }

  /* ── Toggle click ── */
  elToggle.addEventListener('click', async () => {
    const isOn = elToggle.getAttribute('aria-checked') === 'true';

    if (!isOn) {
      // Check coupon conflict first
      if (checkCouponConflict()) {
        shakeToggle();
        return;
      }

      const pts = calcMaxPts();
      console.log('[RP Apply] pts:', pts, '| cartTotal:', cartTotal, '| balance:', state.balance);
      if (pts <= 0) {
        console.warn('[RP Apply] pts is 0 — toggle disabled');
        return;
      }

      showToggleSpinner();

      try {
        const res = await fetch(`${PROXY}/apply`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            customer_id:   customerId,
            points_to_use: pts,
            cart_total:    cartTotal
          })
        });
        const responseText = await res.text();
        console.log('[RP Apply] response status:', res.status, '| body:', responseText);
        if (!res.ok) { throw new Error(JSON.parse(responseText).error || `HTTP ${res.status}`); }
        const data = JSON.parse(responseText);
        if (!data.discount_code) throw new Error('No discount code');

        state.appliedCode = data.discount_code;
        state.appliedPts  = pts;

        saveApplied(data.discount_code, pts);
        await syncCartAttribute(data.discount_code);
        setupCheckoutIntercept(data.discount_code);
        hideToggleSpinner();
        showAppliedState(data.discount_code, pts);
        updateEarnNote(cartTotal, pts);
        await refreshBalance();

      } catch (e) {
        console.error('[RewardsPanel] apply error:', e);
        hideToggleSpinner();
        elToggle.disabled = false;
        alert(e.message === 'Insufficient points'
          ? "Not enough points."
          : 'Something went wrong. Please try again.');
      }

    } else {
      await removeApplied();
    }
  });

  /* ── Remove button ── */
  if (elRemoveApp) elRemoveApp.addEventListener('click', removeApplied);

  /* ── Watch cart for quantity/item changes ──
     When cart total changes while points are applied:
     1. Silently restore points (call /restore)
     2. Reset toggle to OFF
     3. Recalculate with new cart total
     4. Show a notice explaining what happened
  ── */
  function watchCartChanges() {
    // Track the last known cart total from the DOM
    let lastKnownTotal = cartTotal;

    function getCurrentCartTotal() {
      // Read cart total from the panel's data attribute (set at page render)
      // For live updates, read from Shopify cart API
      return fetch('/cart.js')
        .then(r => r.json())
        .then(c => c.total_price)
        .catch(() => lastKnownTotal);
    }

    async function handleCartChange(newTotal) {
      if (!state.appliedCode) return; // nothing applied, ignore
      if (newTotal === lastKnownTotal) return; // no real change

      console.log(`[RewardsPanel] Cart changed: ₹${lastKnownTotal/100} → ₹${newTotal/100}. Resetting points.`);
      lastKnownTotal = newTotal;

      // Silently restore points
      try {
        await fetch(`${PROXY}/restore`, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            customer_id:   customerId,
            points:        state.appliedPts,
            discount_code: state.appliedCode
          })
        });
        await syncCartAttribute('');
      } catch (e) {
        console.error('[RewardsPanel] auto-restore error:', e);
      }

      state.appliedCode = null;
      state.appliedPts  = 0;
      clearApplied();

      const form = panel.closest('form[action]');
      if (form) delete form.dataset.rwrdIntercepted;
      delete panel.dataset.pendingDiscount;

      // Refresh balance from server
      await refreshBalance();

      // Update cartTotal in-place so calcMaxPts uses new value
      cartTotal = newTotal;
      panel.dataset.cartTotal = String(newTotal);

      // Recalculate everything with new cart total
      renderBalance();          // updates usable pts display
      showFreshState();         // toggle OFF, correct max pts
      updateEarnNote(cartTotal, 0);
      updateCartTotalDisplay(0);

      // Show brief notice
      showCartChangedNotice();
    }

    function showCartChangedNotice() {
      // Reuse conflict notice element with a different message
      if (elConflict) {
        elConflictTxt.textContent = 'Cart updated — points reset. Toggle to reapply.';
        elConflict.style.background = '#eaf5ee';
        elConflict.style.borderColor = 'rgba(26,122,74,0.3)';
        elConflict.style.color = '#1a7a4a';
        elConflict.style.display = 'flex';
        // Auto-hide after 4 seconds
        setTimeout(() => {
          if (elConflict) {
            elConflict.style.display = 'none';
            // Reset styles for coupon conflict use
            elConflict.style.background = '';
            elConflict.style.borderColor = '';
            elConflict.style.color = '';
          }
        }, 4000);
      }
    }

    // ── Listen for all cart update events ──
    // Prestige fires these events after AJAX cart updates
    const cartEvents = [
      'cart:updated',           // generic
      'cart:refresh',
      'theme:cart:updated',     // Prestige specific
      'CartUpdate',
    ];
    cartEvents.forEach(evt => {
      document.addEventListener(evt, async (e) => {
        const newTotal = e.detail?.cart?.total_price
          ?? e.detail?.total_price
          ?? await getCurrentCartTotal();
        await handleCartChange(newTotal);
      });
    });

    // ── Also watch the cart total DOM element for text changes ──
    // This catches cases where theme doesn't fire a JS event
    const totalRow = document.querySelector('.cart-recap .h-stack.justify-start.gap-2');
    const totalSpan = totalRow?.querySelectorAll('.text-lg')[1];
    if (totalSpan) {
      let lastText = totalSpan.textContent;
      const totalObserver = new MutationObserver(async () => {
        if (!state.appliedCode) return;
        const currentText = totalSpan.textContent;
        if (currentText !== lastText) {
          lastText = currentText;
          const newTotal = await getCurrentCartTotal();
          await handleCartChange(newTotal);
        }
      });
      totalObserver.observe(totalSpan, { characterData: true, childList: true, subtree: true });
    }
  }

  /* ── Init ── */
  (async function init() {
    elBalance.classList.add('loading');
    elHistList.innerHTML = '<div class="rewards-panel__history-empty">Loading…</div>';
    updateEarnNote(cartTotal, 0);

    try {
      const res  = await fetch(`${PROXY}/points?customer_id=${customerId}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      state.balance      = data.balance      || 0;
      state.history      = data.history      || [];
      state.isFirstOrder = data.is_first_order ?? false;
      state.initialized  = true;

      elBalance.classList.remove('loading');
      renderBalance();
      renderHistory();
      updateEarnNote(cartTotal, 0);

      const saved = loadApplied();

      if (saved) {
        const useEntry = state.history.find(
          h => h.type === 'use' && h.discount_code === saved.code && !h.refunded
        );
        if (useEntry) {
          // Verify code still exists and unused in Shopify
          let codeStillValid = false;
          try {
            const checkRes = await fetch(
              `${PROXY}/check-code?code=${encodeURIComponent(saved.code)}`
            );
            const checkData = await checkRes.json();
            codeStillValid = checkData.valid === true && checkData.usage_count === 0;
          } catch (e) {
            codeStillValid = false;
          }

          if (codeStillValid) {
            state.appliedCode = saved.code;
            state.appliedPts  = saved.pts;
            showAppliedState(saved.code, saved.pts);
            setupCheckoutIntercept(saved.code);
            updateEarnNote(cartTotal, saved.pts);
            updateCartTotalDisplay(saved.pts);
          } else {
            clearApplied();
            showFreshState();
            checkCouponConflict();
          }
        } else {
          clearApplied();
          showFreshState();
          checkCouponConflict();
        }
      } else {
        const recentUnused = state.history.find(
          h => h.type === 'use'
            && h.discount_code
            && h.discount_code.startsWith('RWRD-')
            && !h.refunded
            && (Date.now() - new Date(h.created_at).getTime()) < 2 * 60 * 60 * 1000
        );
        if (recentUnused) {
          // Verify the discount code still exists in Shopify before restoring
          // If it was used in a completed order, it gets deleted — so verify first
          let codeStillValid = false;
          try {
            const checkRes = await fetch(
              `${PROXY}/check-code?code=${encodeURIComponent(recentUnused.discount_code)}`
            );
            const checkData = await checkRes.json();
            codeStillValid = checkData.valid === true && checkData.usage_count === 0;
            console.log('[RewardsPanel] Code check:', recentUnused.discount_code, checkData);
          } catch (e) {
            console.error('[RewardsPanel] Code check failed:', e);
            codeStillValid = false;
          }

          if (codeStillValid) {
            state.appliedCode = recentUnused.discount_code;
            state.appliedPts  = recentUnused.points;
            saveApplied(recentUnused.discount_code, recentUnused.points);
            showAppliedState(recentUnused.discount_code, recentUnused.points);
            setupCheckoutIntercept(recentUnused.discount_code);
            updateEarnNote(cartTotal, recentUnused.points);
            updateCartTotalDisplay(recentUnused.points);
          } else {
            // Code was used/deleted — clear stale history entry
            console.log('[RewardsPanel] Stale code detected, clearing');
            clearApplied();
            showFreshState();
            checkCouponConflict();
          }
        } else {
          showFreshState();
          checkCouponConflict();
        }
      }

      // ── MutationObserver: watch for coupon applied/removed ──
      // Use childList only (NOT characterData) to avoid firing on every keystroke
      const cartRecap = document.querySelector('.cart-recap');
      if (cartRecap) {
        let debounceTimer;
        const observer = new MutationObserver(() => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => checkCouponConflict(), 300);
        });
        observer.observe(cartRecap, { childList: true, subtree: true });
      }

      // ── Watch for cart quantity / item changes ──
      // Prestige updates cart totals via AJAX — we watch the total price element
      // and also listen for Shopify's cart:updated event
      watchCartChanges();

    } catch (e) {
      state.initialized = true;
      elBalance.classList.remove('loading');
      elBalance.textContent = '0';
      if (elBalance2)  elBalance2.textContent  = '0';
      if (elBalanceRs) elBalanceRs.textContent = '0';
      elHistList.innerHTML = '<div class="rewards-panel__history-empty">No activity yet.</div>';
      showFreshState();
      updateEarnNote(cartTotal, 0);
      console.error('[RewardsPanel]', e);
    }
  })();

})();